import { axiosPrivate } from "../config/axios";
import { errorApi, successApi } from "./handle.response.api";

export const getHistoryApi = async (
  dateFrom: string,
  dateTo: string,
  entity: string
) => {
  try {
    const res = await axiosPrivate.get(
      `/histories?dateFrom=${dateFrom}&dateTo=${dateTo}&entity=${entity}`
    );
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi(
      "Lấy danh sách lịch sử thất bại",
      error?.response?.data?.message
    );
  }
};
